import React from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {changeSection} from 'src/redux/aptitude/actions';
import {AptitudeStore} from 'src/types/store';

import styles from './sidebar.module.scss';

const Sidebar = () => {
  const dispatch = useDispatch();
  const aptitude = useSelector((state: AptitudeStore) => state.aptitude);

  const getClassName = (section) => (aptitude.section === section ? styles.current : undefined);
  const handleSectionClick = (section) => () => dispatch(changeSection(section));

  return (
    <nav className={styles.container}>
      <h2 className={styles.title}>aptitude</h2>
      <ul className={styles.items}>
        <li>
          <a href="#color" className={getClassName('color')} onClick={handleSectionClick('color')}>
            Color
          </a>
        </li>
        <li>
          <a href="#logo" className={getClassName('logo')} onClick={handleSectionClick('logo')}>
            Logo
          </a>
        </li>
        <li>
          <a href="#icons" className={getClassName('icons')} onClick={handleSectionClick('icons')}>
            Icons
          </a>
        </li>
        <li>
          <a
            href="#spacing"
            className={getClassName('spacing')}
            onClick={handleSectionClick('spacing')}
          >
            Spacing
          </a>
        </li>
        <li>
          <a
            href="#typography"
            className={getClassName('typography')}
            onClick={handleSectionClick('typography')}
          >
            Typography
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Sidebar;
